function convertEmptyToNull<T extends Record<string, any>>(obj: T): T {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key, 
        value === "" || value === undefined ? null : value
      ])
    ) as T;
  }
  
  function convertEmptyArrayToNull<T extends Record<string, any>>(arr: T[]): T[] {
    return arr.map(obj => convertEmptyToNull(obj));
  }
  
  export { convertEmptyToNull, convertEmptyArrayToNull };